<template>
  <section class="block-countdown">
    <div class="container">
      <h2 class="block-countdown__title" v-if="device_platform !== 'mobile'">
        До конца акции:
      </h2>
      <h2 class="block-countdown__title" v-else>Успей до подорожания</h2>
      <block-clock></block-clock>
      <button
        @click="getCall({ type: 'sale', form: 'countdown' })"
        class="block-countdown__btn button_theme_white"
      >
        Забронировать цену
      </button>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";

import BlockClock from "./block-clock.vue";

export default {
  name: "block-countdown",
  components: { BlockClock },
  mixins: [Mixin],
  methods: {
    handleAgreement() {
      this.$emit("getAgreement");
    },
    handleCallback(data) {
      this.$emit("callBack", data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";
.block-countdown {
  background: linear-gradient(180deg, #092333 45.31%, #1c465f 100%);
  padding: 57px 0;
  color: #fff;
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-weight: 500;
    font-size: 57px;
  }

  &__btn {
    max-width: 258px;
    height: 50px;
  }
}

@media (max-width: 1200px) {
  .block-countdown {
    .container {
      flex-direction: column;
    }

    &__title {
      margin-bottom: 13px;
      text-align: center;
    }

    &__btn {
      margin-top: 30px;
    }
  }
}

@media (max-width: 640px) {
  .block-countdown {
    padding: 25px 0 33px 0;

    &__title {
      font-size: 18px;
    }

    &__btn {
      max-width: 100%;
    }
  }
}
</style>
